import { render, staticRenderFns } from "./NewsArticle.vue?vue&type=template&id=5885feac&scoped=true"
import script from "./NewsArticle.vue?vue&type=script&setup=true&lang=ts"
export * from "./NewsArticle.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./NewsArticle.vue?vue&type=style&index=0&id=5885feac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5885feac",
  null
  
)

export default component.exports